export default "__VITE_ASSET__COQXghbI__"